import React from 'react'

import IBModalAction from 'components/common/IBModalAction/IBModalAction'
import { useGlobalContext } from 'providers/GlobalProvider'
import { formatSeconds } from 'utils/functions/formatString'

interface IdleModalProps {
  isOpen: boolean;
  onClose: () => void;
  remainingTime: number;
  closeSession: () => void;
}
export const IdleModal = ({ isOpen, onClose, remainingTime, closeSession }: IdleModalProps) => {
  const { setShowCollaboratorsModal } = useGlobalContext()
  // if collaborators modal is open, close it
  if (isOpen){
    setShowCollaboratorsModal(false)
  }
  return (
    <IBModalAction
    isOpen={isOpen}
    onClose={onClose}
    data-testid='idle-modal-test-id'
    buttonActionText='Cerrar sesión'
    buttonAction={closeSession}
    buttonCancel='Mantener abierta'
    title='¿Seguís ahí?'
    textBody={`Notamos que hace unos minutos dejaste de usar la página. Por tu seguridad vamos a cerrar la sesión en ${formatSeconds(remainingTime) }.`}
    iconView='precaution'
    buttonCancelProps={{ color: 'blue' , variant: 'outline' }}
  />
  )
}  
